export default __webpack_public_path__ + "static/media/pause.6f34bb41.svg";